
/**
 * @class UsersService
 * @description
 *   Used to get current user role, to check if user is an admin etc.
 * */
class UsersService {
  constructor () {
    this.user = null;
    this.isLoading = false;
    this.roles = {
      admin: 'admin',
      employer: 'employer',
      worker: 'worker'
    };
  }

  /**
   * @member isAdmin
   * @return {boolean}
   * @public
   * */
  isAdmin = () => this.getUserRole() === this.roles.admin;

  /**
   * @member isEmployer
   * @return {boolean}
   * @public
   * */
  isEmployer = () => this.getUserRole() === this.roles.employer;

  /**
   * @member isWorker
   * @return {boolean}
   * @public
   * */
  isWorker = () => this.getUserRole() === this.roles.worker;

  /**
   * @member getUserRole
   * @return {string|undefined}
   * @public
   * */
  getUserRole = () => this.isUserExists() ? this.user.name : undefined;

  /**
   * @member getRoles
   * @return {object}
   * @public
   * */
  getRoles = () => this.roles;

  /**
   * @member isUserExists
   * @return {boolean}
   * @public
   * */
  isUserExists = () => this.user !== null;

  /**
   * @member saveUser
   * @param {object} user
   * @public
   * */
  saveUser = user => {
    this.user = user;
  };

  /**
   * @member deleteUser
   * @public
   * */
  deleteUser = () => {
    this.user = null;
  };

  startLoading = () => {
    this.isLoading = true;
  };

  stopLoading = () => {
    this.isLoading = false;
  }
}

export default new UsersService();



// WEBPACK FOOTER //
// ./src/services/UsersService.js